import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

import { LogosFilters } from '../types';

export const useLogosFilters = createTableFiltersState<LogosFilters>({
  tableKey: TableKeyEnum.LOGOS,
});
